"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlockActive = void 0;
const slate_1 = require("slate");
exports.isBlockActive = (editor, format) => {
    const [match] = slate_1.Editor.nodes(editor, {
        match: (n) => !slate_1.Editor.isEditor(n) && slate_1.Element.isElement(n) && n.type === format,
    });
    return !!match;
};
//# sourceMappingURL=is-block-active.js.map